import {FC} from 'react'

import {theme} from '@/theme/theme'

import {Icon, IconProps} from './Icon'

export const UserIcon: FC<IconProps> = ({color = theme.palette.text.default, size}) => (
  <Icon size={size}>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.16699 16.6667C4.16699 14.5833 5.83366 13 7.83366 13H12.0837C14.167 13 15.7503 14.6667 15.7503 16.6667"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5002 4.3335C13.9169 5.75016 13.9169 8.00016 12.5002 9.3335C11.0836 10.6668 8.83357 10.7502 7.50024 9.3335C6.1669 7.91683 6.08357 5.66683 7.50024 4.3335C8.9169 3.00016 11.0836 3.00016 12.5002 4.3335"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </Icon>
)
